import React, { ChangeEvent } from 'react';
import { ICustomer } from './Customer.model';
import { ItemCreationSubsection, IItemCreationSubsectionInputProps } from '~/Components';
import { useTranslation } from 'react-i18next';
import { ItemCreationValidInput } from '~/Components/ItemCreation/ItemCreationSubsection/ItemCreationSubsectionInput.model';
import { Checkbox, FormControlLabel } from '~/UIKit';
import { connect, getIn, FormikContextType } from 'formik';

export const CreateCustomerForm = connect<{}, any>(
  ({ formik }: { formik: FormikContextType<any> }) => {
    const { t } = useTranslation();

    const sendInviteCheck: boolean = getIn(formik.values, 'sendInvite');
    const emailField: string = getIn(formik.values, 'email');

    const sendInviteHandler = (event: ChangeEvent<HTMLInputElement>) => {
      formik.setFieldValue('sendInvite', event.target.checked);
    };

    const GeneralSectionInputs: IItemCreationSubsectionInputProps<Partial<ICustomer>>[] = [
      {
        label: `${t('app.firstName')}*`,
        type: ItemCreationValidInput.TEXT,
        name: 'firstname',
        InputProps: { multiline: true, maxRows: 2, inputProps: { maxLength: 50 } },
        placeholder: ' ',
      },
      {
        label: `${t('app.lastName')}*`,
        type: ItemCreationValidInput.TEXT,
        name: 'lastname',
        placeholder: ' ',
      },
      {
        label: t('app.customer.email'),
        type: ItemCreationValidInput.TEXT,
        name: 'email',
        placeholder: ' ',
      },
      {
        label: t('app.customer.phone'),
        type: ItemCreationValidInput.TEXT,
        name: 'phone',
        placeholder: ' ',
      },
      {
        customElement: (
          <FormControlLabel
            control={<Checkbox onChange={sendInviteHandler} checked={sendInviteCheck} />}
            label={t('app.customer.sendInvite')}
            name="sendInvite"
            disabled={!emailField}
          />
        ),
      },
    ];

    return (
      <div>
        <ItemCreationSubsection
          title="EVENT_TICKET_GENERAL_SECTION"
          isHeaderVisible={false}
          items={GeneralSectionInputs}
          noBorder
        />
      </div>
    );
  },
);
